module.exports = __webpack_public_path__ + "5e524181e820a4fe1d2d0c5e7fa8aea1.pdf";